import { connect } from 'react-redux'
import { setErrorMessage } from 'actions/account'
import { resetCartForm } from 'actions/account/cart'

const mapStateToProps = ({ cart: { cartForm } }) => ({ cartForm })
const actions = { setErrorMessage, resetCartForm }

const withRedux = connect(
  mapStateToProps,
  actions
)

export default withRedux
